'use client';
import { UserProfile, Book } from 'types';
import Card from '~/components/card';
import Text from '@/components/typography/text';
import UserReviewStars from '@/components/user-review-stars';
import Link from 'next/link';
import BookTile from '@/components/tiles/book';
import BundleAddToCart from './bundle-add-to-cart';
import styles from '@/styles/components/bundle-seller-tile.module.scss';
import UserProfileImage from '~/components/user-profile-image';
import { Box } from '~/components/layout/box';
import { Flex } from '~/components/layout/flex';
import TileRow from '@/components/tile-row';

interface SellerWithBooks extends UserProfile {
  books: Book[];
  bundlePrice: number;
}

export default function BundleSellerTile({
  seller,
}: {
  seller: SellerWithBooks;
}) {
  const serializedBooks = seller.books.map((book) =>
    JSON.parse(JSON.stringify(book))
  );

  if (seller.books.length < 2) {
    return null;
  }

  function renderSellerDetails() {
    return (
      <Flex direction="row" align="center" justify="flex-start" gap={20}>
        <Box style={{ minWidth: 50, minHeight: 50, width: 50, height: 50 }}>
          <UserProfileImage user={seller} />
        </Box>
        <Flex
          direction="column"
          align="flex-start"
          justify="flex-start"
          gap={5}
        >
          <Link href={`/bookstore/${seller.username}`} target="_blank">
            <Text size="base">{seller.username}</Text>
          </Link>
          <UserReviewStars
            user={JSON.parse(JSON.stringify(seller))}
            withCountText={true}
          />
          {seller?.ships_from_state?.name && (
            <Text
              size="small"
              color={'copy'}
            >{`Ships from ${seller.ships_from_state.name}`}</Text>
          )}
        </Flex>
      </Flex>
    );
  }

  if (!seller.books) {
    return null;
  }

  return (
    <Card style={{ width: '100%' }}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.booksSection}>
            <TileRow
              title={' '}
              // title={`Books from ${seller.username}`}
              tileStyle="seller"
              hideScrollbar={false}
            >
              {seller.books.map((book) => (
                <BookTile
                  key={book.id}
                  book={JSON.parse(JSON.stringify(book))}
                  source={'bundle-search'}
                />
              ))}
            </TileRow>
          </div>
          <Flex
            direction="column"
            align="center"
            justify="center"
            gap={30}
            style={{ width: '100%' }}
          >
            <Text align={'center'} size="large">
              ${(seller.bundlePrice / 100).toFixed(2)}
            </Text>
            <BundleAddToCart books={serializedBooks} />
            {renderSellerDetails()}
          </Flex>
        </div>
      </div>
    </Card>
  );
}
